import { render } from "./MenuManage.vue?vue&type=template&id=8c762318&scoped=true"
import script from "./MenuManage.vue?vue&type=script&lang=js"
export * from "./MenuManage.vue?vue&type=script&lang=js"

import "./MenuManage.vue?vue&type=style&index=0&id=8c762318&scoped=true&lang=css"
import "./MenuManage.vue?vue&type=style&index=1&id=8c762318&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c762318"]])

export default __exports__